import React from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { MobileNav } from "./MobileNav";
import { WhatsAppButton } from "./WhatsAppButton";
import { RenovationBanner } from "./RenovationBanner";

export function Layout({ children }) {
  return (
    <div className="App min-h-screen flex flex-col">
      <RenovationBanner />
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <div className="lg:hidden h-16" />
      <MobileNav />
      <WhatsAppButton />
    </div>
  );
}
